import React from "react";
import { useMediaQuery } from 'react-responsive';

const PC = ({children}:{children: JSX.Element}):JSX.Element | null => {
  const isPC = useMediaQuery({
    // query : "(min-width:768px)"
        query : "(min-width:821px)"
  });
  
  return isPC ? children : null;
  }


// const Tablet = ({children}) => {
//   const isMobile = useMediaQuery({
//     query : "(min-width:576px) and (max-width:767px)"
//   });
  
//   return <React.Fragment>{isMobile && children}</React.Fragment>
//   }

const Mobile = ({children}:{children: JSX.Element}):JSX.Element | null => {
  const isMobile = useMediaQuery({
    // query : "(min-width:321px) and (max-width:575px)"
    query : "(max-width:820px)"
  });

  return isMobile ? children : null;
}

//   const Mini = ({children}) => {
//     const isPc = useMediaQuery({
//       query : "(max-width:320px) "
//     });
//     return <React.Fragment>{isPc && children}</React.Fragment>
//     }
  

export { PC, Mobile };